import { defineMessages } from "react-intl";

export const batchMessages = defineMessages({
  registerTitle: {
    id: "RUW+YS",
    defaultMessage: "Register batch",
    description: "batch dialog title when an admin registers a new batch",
  },
  editTitle: {
    id: "9EkMIG",
    defaultMessage: "Edit batch details",
    description: "batch dialog title when an admin edits an existing batch",
  },
  arrivalAt: {
    id: "BeeJDL",
    defaultMessage: "Arrival date and time",
    description: "batch form field, when the goods arrived",
  },
  supplier: {
    id: "O+PWDu",
    defaultMessage: "Supplier",
    description: "batch form field",
  },
  reference: {
    id: "39wzMO",
    defaultMessage: "Delivery note / invoice reference",
    description: "batch form field identifying the shipment",
  },
  isEstimated: {
    id: "zFHANF",
    defaultMessage: "Not arrived yet: this is an estimated arrival (ETA)",
    description: "batch form checkbox, the arrival date is only an estimate",
  },
  etaBadge: {
    id: "oK3j42",
    defaultMessage: "ETA, not arrived yet",
    description: "batch list tag next to an estimated arrival date",
  },
  arrivalEditHint: {
    id: "E/+HNr",
    defaultMessage:
      "When the delivery arrives, set the real arrival time and untick ETA. It applies to every variant of this delivery; the batch code stays the same, so labels already printed still match.",
    description: "batch edit dialog hint under the arrival date field",
  },
  referenceHint: {
    id: "ODGanA",
    defaultMessage:
      "Variants registered with the same supplier and reference share one batch code (one delivery).",
    description: "batch form hint explaining how shipments map to a batch code",
  },
  quantity: {
    id: "/nw9DC",
    defaultMessage: "Quantity received",
    description: "batch form field",
  },
  notes: {
    id: "fA3Y9I",
    defaultMessage: "Notes",
    description: "batch form field",
  },
  cancel: {
    id: "4EIZMP",
    defaultMessage: "Cancel",
    description: "batch dialog button",
  },
  register: {
    id: "cRyQ2c",
    defaultMessage: "Register batch",
    description: "batch dialog primary button",
  },
  save: {
    id: "DGE0XN",
    defaultMessage: "Save",
    description: "batch dialog primary button when editing",
  },
  duplicateShipment: {
    id: "4JUM7B",
    defaultMessage: "This variant is already registered for that shipment.",
    description: "batch dialog error when the same delivery is registered twice for a variant",
  },
  genericError: {
    id: "ofdRXq",
    defaultMessage: "Could not save the batch.",
    description: "batch dialog error fallback",
  },
  pageTitle: {
    id: "i9x3Xl",
    defaultMessage: "Batches",
    description: "breadcrumb / heading of the admin batch control page",
  },
  pageDescription: {
    id: "+dCyNk",
    defaultMessage:
      "Every batch registered for printed labels, with its arrival details and the products it belongs to. Only admins can register or change batches.",
    description: "batch control page description",
  },
  search: {
    id: "CFBL04",
    defaultMessage: "Search by code, SKU, product, supplier or reference",
    description: "batch control page search placeholder",
  },
  columnCode: {
    id: "a3oUGk",
    defaultMessage: "Batch",
    description: "batch table column",
  },
  columnProduct: {
    id: "6Tbm93",
    defaultMessage: "Product / variant",
    description: "batch table column",
  },
  columnArrival: {
    id: "xlkGTF",
    defaultMessage: "Arrival",
    description: "batch table column",
  },
  columnSupplier: {
    id: "iZ6z9v",
    defaultMessage: "Supplier / reference",
    description: "batch table column",
  },
  columnQuantity: {
    id: "vPaAPN",
    defaultMessage: "Qty",
    description: "batch table column",
  },
  columnRegisteredBy: {
    id: "Xfb7I4",
    defaultMessage: "Registered by",
    description: "batch table column",
  },
  edit: {
    id: "UWS5Dx",
    defaultMessage: "Edit",
    description: "batch table row action",
  },
  empty: {
    id: "D8mSur",
    defaultMessage: "No batches registered yet.",
    description: "batch table empty state",
  },
  adminOnly: {
    id: "554bM1",
    defaultMessage: "Only admins can manage batches.",
    description: "batch control page shown to non-admins",
  },
  openBatches: {
    id: "knTnOv",
    defaultMessage: "Batch control",
    description: "button on the print labels page opening the admin batch page",
  },
  noBatchYet: {
    id: "A9EsLY",
    defaultMessage: "No batch registered",
    description: "queue row hint when a variant has no batch and the user can't create one",
  },
  registerBatch: {
    id: "xxiRKe",
    defaultMessage: "Register batch",
    description: "queue row button (admins) opening the batch dialog",
  },
  registerNewBatch: {
    id: "2dH7Ul",
    defaultMessage: "New batch",
    description: "queue row button (admins) when the variant already has a batch",
  },
});
